exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{height:100vh;background-color:#f9f9f9;font-family:ZhiFont,\\.SFNSText-Regular,Helvetica Neue,Roboto,Segoe UI,sans-serif;overflow:auto;-webkit-overflow-scrolling:touch}.preventScroll .main__content{height:calc(100vh - 44px);overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/style.css
// module id = 153
// module chunks = 0